import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject} from 'rxjs';

export interface ITangoCardEvent {

  params: {
    utid: string;
    amount: number;
    email: string;
    subject: string;
    message: string;
  };

  result: {
    referenceOrderID: string;
    utid: string;
    rewardName: string;
    amountCharged: {
      value: number;
      currencyCode: string;
      exchangeRate: number;
      total: number;
    };
    denomination: {
      value: number;
      currencyCode: string;
    };
    sender: {
      firstName: string;
      lastName: string;
      email: string;
    };
    recipient: {
      email: string;
      firstName: string;
      lastName: string;
    };
    emailSubject: string;
    message: string;
    sendEmail: boolean;
    status: string;
    campaign: string;
    createdAt: string;
    reward: {
      credentials: {
        'Redemption Link': string;
        'Digital Token': string;
      }
    };
    redemptionInstructions: string;

    // En cas d'erreur:
    timestamp?: Date;
    httpCode?: number;
    httpPhrase?: string;
    errors?: {
      path: string;
      i18nKey: string;
      message: string;
      invalidValue: string;
      constraint: string;
    }[];
  };

}

@Injectable({
  providedIn: 'root'
})
export class TangoCardsService {

  public isResending$: BehaviorSubject<{ [key: string]: boolean }> = new BehaviorSubject<{ [p: string]: boolean }>({});

  private BASE_URL = environment.legacyBaseUrl;

  tangoSearchResult: ITangoCardEvent[] = [];

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
  ) {
  }

  loadTangoDashboardData() {
    const url = `${environment.apiUrl}/rewards/adminActions`;
    return this.http.post<any>(url, {
      action: 'tangoCardGetInformations',
      params: {},
    });

  }

  sendCard(utid, amount, email, subject, message) {

    const url = `${this.BASE_URL}/4dm1n/api/v2/tangoSendCard`;

    return this.http.post<any>(url,
      {
        utid,
        amount,
        email,
        subject,
        message
      }
    );
  }

  getTangoCardsTransactions(emails: string[]) {

    this.tangoSearchResult = [];

    const url = `${environment.apiUrl}/4dm1n/actions`;
    return this.http.post<any>(url, {
      action: 'getTangoCardsTransactions',
      params: {
        emails,
      },
    });

  }

  resendCard(referenceOrderID: string) {

    this.isResending$.next(
      {
        ...this.isResending$.value,
        [referenceOrderID]: true,
      }
    );

    const url = `${environment.apiUrl}/appCommunity/actions`;
    const actionName = 'resendCard';
    const body = {
      action: actionName,
      params: {
        referenceOrderID,
      },
    };
    return this.http.post<any>(url, body).subscribe((response) => {

      console.log(response);
      this.toastr.success
      (
        `<pre>${JSON.stringify(response.data)}</pre>`,
        `Commande ${referenceOrderID} envoyée de nouveau.`,
        {
          timeOut: 2000,
          progressBar: true,
          enableHtml: true,
        });

      this.isResending$.next(
        {
          ...this.isResending$.value,
          [referenceOrderID]: false,
        }
      );


    });

  }


  clearDatas() {
    this.tangoSearchResult = [];
  }

  setTangoSearchResult(datas) {
    this.tangoSearchResult = datas;
  }

  getTangoSearchResult() {
    return this.tangoSearchResult;
  }


}
